<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <ArgonButton :to="{ name: 'Manajemen Pegawai' }" isRouteLink>
                Kembali</ArgonButton>
            </div>
          </MetaSection>
        </GridCol>
        <GridRow size="12">
          <form @submit.prevent="submit()">
            <cards title="Form Pengguna" headerstyle="background-color: #ebeffb;" footerstyle="background-color: #ebeffb;"
              :useFooter="true" withmin>
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton>Simpan</ArgonButton>
                    <ArgonButton :to="{ name: 'Manajemen Pegawai' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <form>
                <FieldsetComponent title="Informasi Pegawai"
                  description="Isi kolom di samping dengan baik dan benar agar data pegawai tercatat dalam aplikasi">
                  <div class="flex flex-col gap-5">
                    <FormGroup label="Nama" idinput="name">
                      <input type="text" name="name" id="name" class="form-control" v-model="data.name">
                    </FormGroup>

                    <FormGroup label="NIP" idinput="nip">
                      <input type="text" name="nip" id="nip" class="form-control" v-model="data.nip" disabled>
                    </FormGroup>

                    <form-group label="Jenis Kelamin">
                      <div class="d-flex flex-row gap-4 align-items-center">
                        <argon-radio id="gender_0" name="gender" text="Laki-Laki" v-model="data.gender" value="male" />
                        <argon-radio id="gender_1" name="gender" text="Perempuan" v-model="data.gender" value="female" />
                      </div>
                    </form-group>

                    <FormGroup label="Email" idinput="email">
                      <input type="email" name="email" id="email" class="form-control" v-model="data.email">
                    </FormGroup>

                    <FormGroup label="Status Pegawai">
                      <select-form name="status_pegawai" style="text-transform: capitalize;" idinput="status_pegawai" v-model="data.employee_status" :options="employeeStatus.map((item) => {
                        return {
                          value: item,
                          text: item.toLocaleLowerCase(),
                        };
                      })" />
                    </FormGroup>

                    <FormGroup label="Hak Akses" idinput="hakases">
                      <select-form v-model="data.group_id" name="hakakses" idinput="hakakses" placeholder="Pilih Hak Akses" :options="groups.map((item) => {
                        return {
                          value: item.id,
                          text: item.name,
                        };
                      })" />
                    </FormGroup>

                    <FormGroup label="Foto Pegawai">
                      <div class="d-flex flex-column gap-2">
                        <input @change="onChangePhoto($event)" type="file" name="photo" id="photo" class="d-none"
                          accept="image/jpeg">
                        <div>
                          <label for="photo" type="button" class="btn mb-0 undefined btn-md null null"
                            style="border: solid rgb(3, 133, 243);">Klik untuk mengunggah foto</label>
                        </div>
                        <div v-if="url != ''" style="width: 11.1112vw;height: 11.1112vw;position: relative;">
                          <img :src="url" alt="Uploaded" class="img-fluid" style="width: 11.1112vw;height: 11.1112vw;">
                          <div @click="url = ''"
                            style="background-color: rgb(3, 133, 243);color: rgb(255, 255, 255);position: absolute;bottom: .5rem;right: .5rem;">
                            <ArgonButton>Hapus</ArgonButton>
                          </div>
                        </div>
                      </div>
                    </FormGroup>

                    <form-group v-if="this.$route.params.id" label="Status">
                      <div class="d-flex flex-row gap-4 align-items-center">
                        <argon-radio id="status_0" name="status" text="Aktif" v-model="data.status" value="active" />
                        <argon-radio id="status_1" name="status" text="Non Aktif" v-model="data.status" value="inactive" />
                      </div>
                    </form-group>
                  </div>
                </FieldsetComponent>

                <FieldsetComponent title="Informasi Jabatan"
                  description="Pastikan informasi ini diisi dengan tepat sesuai jabatan pegawai">
                  <FormGroup label="Unit Kerja" idinput="unitkerja_id">
                    <select-form @change="getJabatan()" name="unitkerja_id" idinput="unitkerja_id" v-model="data.unitkerja_id" :options="unitKerja.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </FormGroup>

                  <FormGroup label="Jabatan" idinput="jabatan_id">
                    <select-form name="jabatan_id" idinput="jabatan_id" v-model="data.jabatan_id" :options="jabatan.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </FormGroup>

                  <FormGroup label="Posisi" idinput="position">
                    <InputForm name="position" idinput="position" v-model="data.position" />
                  </FormGroup>

                  <FormGroup label="Level" idinput="level">
                    <InputForm type="text" idinput="level" v-model="data.grade" />
                  </FormGroup>
                </FieldsetComponent>

                <FieldsetComponent title="Informasi Atasan"
                  description="Pastikan informasi ini diisi dengan tepat sesuai nama Direct Supervisor dan Immediate Supervisor dari pegawai tersebut">
                  <FormGroup label="Cari Direct Supervisor">
                    <input type="text" name="keyword" id="keyword" class="form-control" @keyup="searchEmployee()"
                      v-model="employeeKeyword">
                  </FormGroup>

                  <div v-if="searchedEmployees.length > 0" class="table-responsive border">
                    <table class="table table-hover m-0">
                      <thead>
                        <tr>
                          <th>Nama</th>
                          <th>Jabatan</th>
                          <th>Unit Kerja</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(employee, index) in searchedEmployees" :key="index" class="border-bottom text-center"
                          style="line-height: 58px;" @click="pilihDirectSupervisor(employee)">
                          <td>
                            {{ employee.name ?? "" }}
                          </td>
                          <td>{{ employee.jabatan?.name ?? "" }}</td>
                          <td>{{ employee.jabatan?.unitkerja?.name ?? "" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <FormGroup label="Direct Supervisor">
                    <div class="form-control">{{ data?.leader?.name ?? "&nbsp;" }}</div>
                  </FormGroup>

                  <FormGroup label="NIP Direct Supervisor">
                    <div class="form-control">{{ data?.leader?.nip ?? "&nbsp;" }}</div>
                  </FormGroup>

                  <!-- <FormGroup label="Immediate Manager" invalidmsg="Immediate manager belum di set, silahkan atur immediate manager di master data unit kerja" idinput="atasan1">
                    <div :class="{'form-control': true, 'is-invalid': !data?.unitkerja?.leader}">{{ unitKerja.find((item) => {
                      return item.id == data.unitkerja_id
                    })?.leader?.name ?? "" }}</div>
                  </FormGroup>

                  <FormGroup label="NIP Immediate Manager" invalidmsg="Immediate manager belum di set, silahkan atur immediate manager di master data unit kerja" idinput="nipatasan1">
                    <div :class="{'form-control': true, 'is-invalid': !data?.unitkerja?.leader}">{{ data?.unitkerja?.leader?.nip ?? "&nbsp;" }}</div>
                  </FormGroup> -->

                  <FormGroup label="Immediate Manager" invalidmsg="Immediate manager belum di set, silahkan atur immediate manager di master data unit kerja" idinput="atasan1">
                    <div :class="{'form-control': true, 'is-invalid': !data?.immediate_supervisor}">
                      {{ data?.immediate_supervisor?.name }}
                    </div>
                  </FormGroup>

                  <FormGroup label="NIP Immediate Manager" invalidmsg="Immediate manager belum di set, silahkan atur immediate manager di master data unit kerja" idinput="nipatasan1">
                    <div :class="{'form-control': true, 'is-invalid': !data?.immediate_supervisor}">{{ data?.immediate_supervisor?.nip ?? "&nbsp;" }}</div>
                  </FormGroup>
                </FieldsetComponent>
              </form>
            </cards>
          </form>
        </GridRow>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import EmployeesApi from "@/repository/api/EmployeesApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import JabatanApi from "@/repository/api/JabatanApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import EmployeeApi from '@/repository/api/EmployeeApi';
import GroupsApi from "@/repository/api/GroupsApi";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputForm from "@/components/InputForm.vue";
import ArgonRadio from '@/components/ArgonRadio.vue';
import SelectForm from '@/components/SelectForm.vue';
export default {
  name: "profile",
  data() {
    return {
      employeeStatus: ["tetap", "kontrak", "magang"],
      isEdit: false,
      showMenu: false,
      data: {
        jabatan: {
          grade: ""
        }
      },
      employees: [],
      employee: {},
      unitKerja: [],
      jabatan: [],
      groups: [],
      timer: null,
      employeeKeyword: "",
      url: "",
      searchedEmployees: [],
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    // Select2,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    InputForm,
    ArgonRadio,
    SelectForm,
  },

  async mounted() {
    this.$store.state.loading = true;
    if (this.$route.params.id) {
      this.isEdit = true;
      await this.getData();
    }
    await this.getGroups();
    await this.getUnitKerja();
    await this.getAllEmployees();
    this.$store.state.loading = false;
    this.$store.state.isAbsolute = true;
  },
  watch: {
    "employeeKeyword": {
      handler: function () {
        if (this.employeeKeyword == undefined || this.employeeKeyword == "" || this.employeeKeyword.length < 3) {
          this.searchedEmployees = [];
        }
      }
    },
    "data.unitkerja_id": {
      handler: async function () {
        await this.getJabatan();
      },
      deep: true,
    }
  },
  methods: {
    onChangePhoto(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    pilihDirectSupervisor(item) {
      // direct
      this.data.leader = JSON.parse(JSON.stringify(item));
      this.data.leader_id = this.data.leader.id;

      // immediate
      if (item?.leader) {
        this.data.immediate_supervisor = JSON.parse(JSON.stringify(item.leader));
        this.data.immediate_supervisor_id = this.data?.immediate_supervisor?.id;
      }

      this.employeeKeyword = "";
      this.searchedEmployees = [];
    },
    async pilihEmployee(item) {
      this.employee = item;
      this.data.username = this.employee?.nip;
      let name = String(this.employee.name).split(" ")
      this.data.first_name = name.splice(0, 1)[0]
      this.data.last_name = name.join(' ')
      this.data.name = this.employee.name
      this.data.unitkerja_id = await (this.employee?.jabatan?.unitkerja_id ?? null)
      await this.getJabatan();
      this.data.jabatan_id = this.employee?.jabatan?.id ?? null
    },
    async searchEmployee() {
      if (this.employeeKeyword.length > 0) {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          await EmployeeApi.getByKeyword(this.employeeKeyword).then((response) => {
            this.searchedEmployees = response.data;
          }).catch(() => {
            this.searchedEmployees = [];
            this.$swal({
              icon: "error",
              title: "Data tidak ditemukan",
            });
          });
        }, 650);
      } else {
        this.searchedEmployees = [];
      }

      // if (this.employeeKeyword.length > 3) {
      //   await EmployeeApi.getByKeyword(this.employeeKeyword).then((response) => {
      //     this.searchedEmployees = response.data;
      //   }).catch(() => {
      //     this.$swal({
      //       icon: "error",
      //       title: "Data tidak ditemukan",
      //     });
      //   });
      // }
    },
    async getUnitKerja() {
      await UnitKerjaApi.getbyparam({status: "active", page: "all"}).then(async (response) => {
        this.unitKerja = response.data;
        this.unitKerja = this.unitKerja.filter((item) => {
          return !['inactive'].includes(item.status);
        });
      }).catch(() => {
        this.unitKerja = [];
      });
    },
    async getJabatan() {
      await JabatanApi.getbyparam({ unitkerja_id: this.data.unitkerja_id, status: '1', page: "all" }).then((response) => {
        this.jabatan = response.data;
      }).catch(() => {
        this.jabatan = [];
      });
    },
    async submit() {
      if (this.$route.params.id) {
        let data = new FormData()

        console.log(this.data)
        Object.keys(this.data).forEach((key) => {
          switch (key) {
            case "photo":
              let file = this.$el?.querySelector("input[type='file']")?.files?.[0] ?? undefined;
              if (file !== undefined) {
                data.append("photo", file);
              }
              break;
            default:
              if (this.data?.[key]) {
                data.append(key, this.data?.[key])
              }
              break;
          }
        })
        await EmployeesApi.update(this.$route.params.id, data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Manajemen Pegawai" });
          })
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: "Gagal menyimpan",
            text: (typeof error?.response?.data?.message) == "string" ? error?.response?.data?.message : ""
          });
        });
      }
      else {
        await EmployeesApi.post(this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Manajemen Pegawai" });
          });
        }).catch((error) => {
          console.log(typeof error?.response?.data?.message)
          this.$swal({
            icon: "error",
            title: "Gagal Menyimpan",
            text: (typeof error?.response?.data?.message) == "string" ? error?.response?.data?.message : ""
          });
        });
      }
    },
    async getAllEmployees() {
      await EmployeeApi.getbyparam({view_option:1}).then((response) => {
        this.employees = response.data;
      }).catch(() => {
        this.employees = [];
      });
    },
    async getData() {
      await EmployeesApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
        if (this.data.photo != "" && this.data.photo != null) {
          this.url = String(process.env.VUE_APP_BASE_API).replace(/\/$/, '') + this.data.photo
        }
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error.response.data.message,
        }).then(() => {
          this.$router.push({ name: "Dashboard" });
        });
      })
      await this.getJabatan();
    },
    async getGroups() {
      await GroupsApi.get().then((response) => {
        this.groups = response.data
      })
    }
  },
};
</script>
